import { useGetUserTablePreferencesQuery } from 'types/atlas-graphql';

type UseUserTablePreferencesOptions = {
  tableId: string;
  skip?: boolean;
};

export const useUserTablePreferences = ({
  tableId,
  skip = false,
}: UseUserTablePreferencesOptions) => {
  const { data, error, loading, refetch } = useGetUserTablePreferencesQuery({
    variables: { tableId },
    skip: skip || !tableId,
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  return {
    tablePreferences: data?.me?.organizationPreferences?.tablePreferences,
    loading,
    error,
    refetch,
  };
};
